// extracted by mini-css-extract-plugin
export default {"contentContainer":"RefundTransactionContent_contentContainer__M+BaW","spinContainer":"RefundTransactionContent_spinContainer__Tq6HT"};